import { createSlice } from '@reduxjs/toolkit'

export const loadingSlice = createSlice({
    name: 'loading',
    initialState:{
        loading:false
    },
    reducers: {
        setLoadingState: (state) => {
            state.loading = true
        },
        unsetLoadingState: (state) => {
            state.loading = false
        },
    }
})

export const { setLoadingState, unsetLoadingState } = loadingSlice.actions

export default loadingSlice.reducer